import { render, staticRenderFns } from "./result-image.vue?vue&type=template&id=f1ecd8ae&scoped=true"
import script from "./result-image.vue?vue&type=script&lang=js"
export * from "./result-image.vue?vue&type=script&lang=js"
import style0 from "./result-image.vue?vue&type=style&index=0&id=f1ecd8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ecd8ae",
  null
  
)

export default component.exports